import Scene = Phaser.Scene;
import Graphics = Phaser.GameObjects.Graphics;

export default class Blackout extends Phaser.GameObjects.Container {

    private blackoutImage: Graphics | undefined;
    private canvas: HTMLCanvasElement;

    private static blackout: Blackout | undefined = undefined;

    private constructor(scene: Scene, canvas: HTMLCanvasElement, depth: number) {
        super(scene);

        this.scene = scene;
        this.canvas = canvas;

        this.setDepth(depth);
    }

    public static isShowing() {
        return !!Blackout.blackout;
    }

    public static show(scene: Scene, canvas: HTMLCanvasElement, depth: number): boolean {
        if (Blackout.blackout) {
            return false;
        }
        Blackout.blackout = new Blackout(scene, canvas, depth);
        let self = Blackout.blackout;
        if (self.blackoutImage && self.blackoutImage.active) {
            Blackout.blackout.scene.tweens.killTweensOf(self.blackoutImage);
        }

        self.blackoutImage = self.scene!.add.graphics();
        self.add(self.blackoutImage);
        self.setAlpha(0);

        let color = Phaser.Display.Color.HexStringToColor('#000000').color;

        self.blackoutImage.fillRect(0, 0, self.canvas.width, self.canvas.height);
        self.blackoutImage.fillStyle(color);
        self.blackoutImage.setInteractive();

        self.scene.tweens.add({
            targets: self,
            delay: 0,
            alpha: 1,
            duration: 1000,
            onComplete() {
                self.blackoutImage!.setAlpha(1);
            }
        });

        self.scene.add.existing(self);
        Blackout.blackout = self;
        return true;
    }

    public static hide() {
        if (Blackout.blackout && Blackout.blackout.scene) {

            let self = Blackout.blackout;

            if (self) {
                self.scene.tweens.add({
                    targets: self,
                    delay: 3000,
                    alpha: 0,
                    duration: 1000,
                    onComplete() {
                        self.setAlpha(0);
                        self.destroy();
                        Blackout.blackout = undefined;
                    }
                });
            }
        }
    }
}
